module.exports = "<gstc [config]=\"config\" (onState)=\"onState($event)\" *ngIf=\"showChart\"></gstc>"